<template>
    <div>
        <BmvTable
            :columns="tableColumns"
            :data="posts.data || []"
            :loading="isLoading"
            :pagination="false"
        >
            <!-- Reference -->
            <template #cell-id="{ row }">
                {{ row.reference }}
            </template>

            <!-- Form name -->
            <template v-slot:[`cell-form.name`]="{ row }">
                {{ row.form ? row.form.name : '' }}
            </template>

            <!-- Status -->
            <template #cell-status_id="{ row }">
                <StatusBadge :status="row.status" />
            </template>

            <!-- Title -->
            <template #cell-title="{ row }">
                <router-link
                    :to="`/posts/${row.id}`"
                    class="pt-cell-link"
                >
                    {{ row.title || '—' }}
                </router-link>
            </template>

            <!-- Date -->
            <template #cell-created_at="{ row }">
                {{ moment(row.created_at).format('L') }}
            </template>

            <!-- Operator -->
            <template #cell-operator="{ row }">
                <div v-if="row.racis" class="pt-operators">
                    <span
                        v-for="raci in row.racis.filter(r => r.is_responsible == 1)"
                        :key="raci.id"
                        class="pt-operator-badge"
                    >
                        <i class="fal fa-user"></i>
                        {{ raci.name }}
                    </span>
                </div>
            </template>

            <!-- Priority -->
            <template #cell-priority="{ row }">
                <ButtonEditPriority :post="row" />
            </template>

            <!-- Actions -->
            <template #cell-actions="{ row }">
                <div class="d-flex align-items-center" style="gap: 6px;">
                    <button
                        @click.prevent="showPostPreview(row)"
                        class="pt-action-btn pt-action-btn--view"
                    >
                        <i class="fal fa-eye" style="color: #fff !important;"></i>
                    </button>
                    <ButtonRemind variant="minimal" :post="row" />
                </div>
            </template>
        </BmvTable>
        <PostPreviewModal ref="postPreview" :post="setSelectedPost" />
    </div>
</template>

<script>
import BmvTable from '@/components/UI/BmvTable'
import ButtonRemind from '@/components/UI/ButtonRemind'
import { mapActions } from 'vuex'
import PostPreviewModal from '@/components/Model/Post/PostPreviewModal'
import StatusBadge from '@/components/UI/StatusBadge'
import ButtonEditPriority from './ButtonEditPriority'

export default {
    name: 'PostsTable',
    props: ['filterMyOpenedTickets', 'filterMyTrackedTickets', 'citizenPosts'],
    components: {
        BmvTable,
        PostPreviewModal,
        StatusBadge,
        ButtonRemind,
        ButtonEditPriority
    },
    created() {
        this.config.per_page = '10'
        this.filterMyOpenedTickets
            ? (this.config.filters = this.filterMyOpenedTickets)
            : null
        this.filterMyTrackedTickets
            ? (this.config.filters = this.filterMyTrackedTickets)
            : null
        if (this.citizenPosts) {
            this.config.filters = this.citizenPosts
            this.config.per_page = ''
        }
        this.isLoading = true
        this.getPosts().then((response) => {
            this.posts = response.data.posts
            this.isLoading = false
        })
    },
    data() {
        return {
            isLoading: false,
            setSelectedPost: {},
            posts: [],
            tableColumns: [
                { field: 'id', label: this.$t('post.page.tablecolumnlabels.ref'), width: '80px' },
                { field: 'form.name', label: this.$t('post.page.tablecolumnlabels.form'), width: '14%' },
                { field: 'status_id', label: this.$t('post.page.tablecolumnlabels.status'), width: '12%' },
                { field: 'title', label: this.$t('post.page.tablecolumnlabels.subject'), width: '30%' },
                { field: 'created_at', label: this.$t('post.page.tablecolumnlabels.date'), width: '10%' },
                { field: 'operator', label: this.$t('post.page.tablecolumnlabels.operator'), width: '12%' },
                { field: 'priority', label: this.$t('post.page.tablecolumnlabels.priority'), width: '8%', align: 'center' },
                { field: 'actions', label: this.$t('post.page.tablecolumnlabels.shares'), width: '8%', align: 'center' }
            ]
        }
    },
    computed: {
        config: {
            get() {
                return this.$store.state.post.postsConfig
            },
            set(value) {
                this.$store.commit('post/setPostsConfig', value)
            }
        }
    },
    methods: {
        ...mapActions('post', ['getPosts', 'getPost']),
        showPostPreview(post) {
            this.getPost(post.id).then((result) => {
                this.setSelectedPost = result.data.post
            })
            this.$refs.postPreview.trigger()
        }
    }
}
</script>

<style scoped>
.pt-cell-link {
    color: #0f172a;
    text-decoration: none;
    font-weight: 500;
}

.pt-cell-link:hover {
    color: #0891B2;
}

.pt-operators {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
}

.pt-operator-badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 3px 10px;
    background: rgba(8, 145, 178, 0.08);
    color: #0891B2;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 600;
    white-space: nowrap;
}

.pt-operator-badge i {
    font-size: 0.68rem;
}

.pt-action-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
}

.pt-action-btn i {
    font-size: 0.78rem;
}

.pt-action-btn--view {
    background: #0891B2;
}

.pt-action-btn--view:hover {
    background: #0e7490;
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(8, 145, 178, 0.3);
}
</style>
